import { ClientConfigProductName } from '@frontend/vanilla/core';

export const MediaLoader = {
    id: 'media',
    loaderFn: () => import(/* webpackChunkName: "ms-media-widget" */ './media.feature'),
    product: ClientConfigProductName.SPORTS,
};
